export function toArray<T>(value: T | T[] | undefined): T[] | undefined {
  if (value === undefined || value === null) return undefined
  if (Array.isArray(value)) return value
  return [value]
}
